export default "__VITE_ASSET__mIBRKovd__"